export const Z_INDEX = {
    OVERLAY_BACKDROP: 5,
    MENU_DESKTOP: 99,
    LANG_LIST_DESKTOP: 99,
    SUPPORT_MENU_DESKTOP: 99,
    LOCATION_DESKTOP: 999,
    LOCATIONS_LIST: 1000,
    MAP_CONTROLS: 1001,
    LOCATION_LEGEND: 1001,
    LEGEND_DESKTOP: 1001,
    MAP_OVERLAY: 1002,
    MAP_DRAWER: 1003,
    MENU_MODAL: 1050,
    DRAWER_DEFAULT: 1400,
    MENU_BLOCK: 9999,
    LEAFLET_LOADER: 9999,
    DRAWER_LOCATION: 10001,
    DRAWER_FILTER: 10001,
    TERMS_MODAL: 10001,
    PAY_MENU_BLOCK: 10002,
    DRAWER_MENU: 10003,
    DRAWER_SUPPORT: 10003,
    DRAWER_LANG: 10003,
    DRAWER_LEGEND: 10003,
    IMAGE_PREVIEW: 10004,
    TOAST: 10050,
} as const;

export type ZIndexKey = keyof typeof Z_INDEX;
